import { Button } from "@/components/ui/button";
import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { useEntityNavigation } from "routes/entity/useEntityNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.entity.create,
  ACL_RELATIONSHIPS.user.read,
];

/** The Entities table's create action. */
const NewEntityButton = () => {
  const { openCreate } = useEntityNavigation();

  return (
    <Authorized permissions={CREATE_ACLS}>
      <Button size="sm" className="item-adder" onClick={openCreate}>
        New Entity
      </Button>
    </Authorized>
  );
};

export default NewEntityButton;
